import { InvitedProfileDto, Role, UserProfileDto } from '@inosio/payments-sdk';
import ProfileUsersModal from './ProfileUsersModal';
import { useEffect, useState } from 'react';
import CreateNewProfileUserModal from './CreateNewProfileUserModal';
import { Box } from '@mui/system';

export interface UserRegistrationProfileDetails {
  profileRole: Role;
  profileUuid: string;
  profileIntegrationFirstName: string;
  profileIntegrationMiddleName: string;
  profileIntegrationLastName: string;
  profileIntegrationEmail: string;
  UpdateTokenId?: string
}

interface UserRegistrationModalManagerProps {
  /**
   * Object that holds info about the profile
   */
  profileDetails: UserRegistrationProfileDetails;
  /**
   * List of registered users that roll up to a profile
   */
  profileUsers: UserProfileDto[];
  /**
   * List of invited users that roll up to a profile
   */
  profileInvitedUsers: InvitedProfileDto[];

  /**
   * Callback fired when the modal manager is closed.
   * @returns
   */
  onClose: () => void;

  /**
   * Bit flag to know when to open the modal managers
   */
  open: boolean;
}

/**
 * Generic user registration modal manager that manages invitations and password reset modals.
 * Keep it generic, don't tighly couple it to a single profile.
 * @param props
 * @returns
 */
const UserRegistrationModalManager = (props: UserRegistrationModalManagerProps) => {
  const [openProfileUsersModal, setOpenProfileUsersModal] = useState(false);
  const [openCreateNewProfileUserModal, setOpenCreateNewProfileUserModal] = useState(false);

  useEffect(() => {
    if (props.profileDetails.profileUuid && (!!props.profileUsers.length || !!props.profileInvitedUsers.length) && props.open) {
      setOpenProfileUsersModal(true);
    } else if (props.profileDetails.profileUuid && props.profileUsers.length === 0 && props.profileInvitedUsers.length === 0 && props.open) {
      setOpenCreateNewProfileUserModal(true);
    }
  }, [props.profileDetails.profileUuid, props.profileUsers, props.open]);

  return (
    <Box>
      <ProfileUsersModal
        open={openProfileUsersModal}
        onClose={() => {
          setOpenProfileUsersModal(false);
          props.onClose();
        }}
        profileUsers={props.profileUsers}
        profileInvitedUsers={props.profileInvitedUsers}
        handleAddNewUser={() => {
          setOpenCreateNewProfileUserModal(true);
          setOpenProfileUsersModal(false);
        }}
        profileDetails={props.profileDetails}
      />
      <CreateNewProfileUserModal
        open={openCreateNewProfileUserModal}
        onClose={() => {
          setOpenCreateNewProfileUserModal(false);
          props.onClose();
        }}
        profileDetails={props.profileDetails}
        profileUsers={props.profileUsers}
        profileInvitedUsers = {props.profileInvitedUsers}
      />
    </Box>
  );
};

export default UserRegistrationModalManager;
